import {
  type MouseEvent as ReactMouseEvent,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { DateFormat, moment, type Nil, Text } from '@pbt/pbt-ui-components'

import { updateSoapTasksSelectedDate } from '~/store/actions/tasks'
import { getAppointmentId } from '~/store/reducers/soap'
import { getSoapTasksSelectedDate } from '~/store/reducers/tasks'
import { getTimetableEvent } from '~/store/reducers/timetable'

import DatePopper from './DatePopper'

const useStyles = makeStyles(
  () => ({
    arrow: {
      verticalAlign: 'middle',
      fontSize: '1.8rem',
    },
    container: {
      userSelect: 'none',
      position: 'relative',
      cursor: 'pointer',
    },
  }),
  { name: 'ToDoDatePicker' },
)

const ToDoDatePicker = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const appointmentId = useSelector(getAppointmentId)
  const appointment = useSelector(getTimetableEvent(appointmentId))
  const selectedDate = useSelector(getSoapTasksSelectedDate)
  const [popperOpen, setPopperOpen] = useState(false)

  const rootRef = useRef<HTMLDivElement>(null)

  const setSelectedDate = (date: string | Nil) => {
    dispatch(updateSoapTasksSelectedDate(date))
  }

  useEffect(() => {
    if (appointment?.scheduledStartDatetime) {
      setSelectedDate(appointment.scheduledStartDatetime)
    }
  }, [appointment?.scheduledStartDatetime])

  const togglePopper = (event: ReactMouseEvent) => {
    event.stopPropagation()
    setPopperOpen(!popperOpen)
  }

  if (!selectedDate) {
    return null
  }

  return (
    <Grid container item alignItems="center" justifyContent="flex-end">
      <Grid
        item
        className={classes.container}
        ref={rootRef}
        onClick={togglePopper}
      >
        <Text inline strong variant="subheading4">
          {moment(selectedDate).format(
            DateFormat.DAY_OF_WEEK_MONTH_DAY_COMMA_YEAR,
          )}
        </Text>
        {popperOpen ? (
          <KeyboardArrowUp className={classes.arrow} />
        ) : (
          <KeyboardArrowDown className={classes.arrow} />
        )}
        <DatePopper
          anchorEl={rootRef.current}
          open={popperOpen}
          placement="top-end"
          value={selectedDate}
          onChange={setSelectedDate}
          onClose={(event) => {
            if (!rootRef.current?.contains(event.target)) {
              setPopperOpen(false)
            }
          }}
        />
      </Grid>
    </Grid>
  )
}

export default ToDoDatePicker
